import { z } from "zod";

import { CourseByIdSchema } from "../courses/Course.use-cases";

import { PreferenceSchema } from "./Preference.schema";

export const UpdatePreferenceSchema = PreferenceSchema.pick({
  themeSlug: true,
  color: true,
  customized: true,
  logo: true,
})
  .merge(CourseByIdSchema)
  .partial();

export const RemoveLogoSchema = CourseByIdSchema;

export type GetPreferenceInput = z.infer<typeof CourseByIdSchema>;
export type GetPreferenceOutput = z.infer<typeof PreferenceSchema>;

export type UpdatePreferenceInput = z.infer<typeof UpdatePreferenceSchema>;
export type UpdatePreferenceOutput = z.infer<typeof PreferenceSchema>;

export type RemoveLogoInput = z.infer<typeof RemoveLogoSchema>;
